import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getBankAccount } from '../../services'
import { BankQueryKeys } from '@/modules/bank/keys'
import {
	GetBankAccountResponse,
	GetBankAccountsRequest,
} from '@/modules/bank/type'

export default function useQueryGetBankAccount(
	payload: GetBankAccountsRequest,
	props?: UseBaseQueryOptions<GetBankAccountResponse>,
) {
	return useQuery({
		queryKey: [BankQueryKeys.BankAccounts, payload],
		queryFn: () => getBankAccount(payload),
		...props,
	})
}
